"use strict";
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        /**
         * Helper functions for ApplicationBar and related classes.
         */
        var ActionPaneHelpers;
        (function (ActionPaneHelpers) {
            /**
             * method to process state changes as a control moves in and out of overflow
             * @internal
             * @param controlToMove the control being moved
             * @param isInOverflow true if its moving in to overflow
             */
            function ApplyBarOverflow(controlToMove, isInOverflow) {
                controlToMove.isInOverflow = isInOverflow;
                if (controlToMove.ButtonDisplay === $dyn.ui.ButtonDisplay.imageOnly) {
                    controlToMove.ShowLabel = isInOverflow;
                }
            }
            ActionPaneHelpers.ApplyBarOverflow = ApplyBarOverflow;
            /**
             * Removes given items from the overflow area.
             * @internal
             * @param removableItems Array of items to be moved out of overflow
             */
            function _removeAllOverflow(removableItems) {
                // We always need to remove items from overflow in last in, first out order.
                var indexToMove;
                if (this.TypeName === "AppBarSection") {
                    indexToMove = 0;
                    while (indexToMove <= removableItems.length - 1) {
                        this._removeItemFromOverflow(removableItems[indexToMove]);
                        indexToMove++;
                    }
                }
                else {
                    indexToMove = removableItems.length - 1;
                    while (indexToMove >= 0) {
                        this._removeItemFromOverflow(removableItems[indexToMove]);
                        indexToMove--;
                    }
                }
            }
            ActionPaneHelpers._removeAllOverflow = _removeAllOverflow;
        })(ActionPaneHelpers = util.ActionPaneHelpers || (util.ActionPaneHelpers = {}));
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ActionPaneHelpers.js.map
